@import "../../../../../shared/styles/base";
@import "../../../../../shared/components/design-system/Button/styles//surfaces";

.Card {
  background: $white;
  border-radius: 0.5rem;
  box-shadow: $card-shadow;
  @include white-surface;

  .content {
    padding: 1.5rem;
  }

  .media {
    overflow: hidden;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    margin-bottom: -0.5rem;
  }

  .mediaImage {
    width: 100%;
    height: auto;
  }

  & + & {
    margin-top: 1rem;
  }

  @media screen and (min-width: $tablet) {
    .content {
      padding: 2rem;
      width: 100%;
    }

    &.compact .content {
      padding: 1.5rem;
    }

    .media + .content {
      padding: 1.5rem;
    }
  }
}
